import React, { useEffect, useRef } from 'react';
import { View, Text, ScrollView } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { Icon, Button, Hr } from 'LocalGluons';
import { globalStyles } from 'Theme';
import { Device, getActualHeight } from 'DeviceUtils';
import Orientation from 'react-native-orientation-locker';
import { lockToLandscape } from 'DeviceUtils/DeviceUtils.web';
import { useNavigation } from '@react-navigation/native';
import portraitStyles, { landscapeStyles } from './DeviceLimitDialog.jss';

const DeviceLimitDialog = ({ playerData, close, isLandscape, isFreemium }) => {
    const navigation = useNavigation();
    const styles = isLandscape && !Device.isPhone ? landscapeStyles : portraitStyles;
    const buttonStyle = { button: styles.managementDeviceButton };
    const confirmButtonStyle = { button: styles.confirmButton };
    const switchToLandscape = useRef(false);

    const title = isFreemium ? 'SETTINGS.DEVICE_LIMIT___PACKAGE.BENEFIT' : 'SETTINGS.DEVICE_LIMIT';

    useEffect(() => {
        const isOrientationLocked = Orientation.isLocked();

        Orientation.getOrientation((orientation) => {
            if (
                Device.isPhone &&
                isOrientationLocked &&
                (orientation === 'LANDSCAPE-LEFT' || orientation === 'LANDSCAPE-RIGHT')
            ) {
                Orientation.lockToPortrait();
                switchToLandscape.current = true;
            }
        });

        return () => {
            if (switchToLandscape.current) {
                lockToLandscape();
            }
        };
    }, []);

    const content = (
        <>
            <View style={styles.titleContainer}>
                <Icon style={styles.icon} name="warning_yellow_black" />
                <Text style={globalStyles.title}>{t(title).trim()}</Text>
            </View>
            <Hr style={styles.line} />
            <View style={isFreemium ? styles.higherDescriptionBlock : styles.descriptionBlock}>
                <ScrollView contentContainerStyle={styles.scrollViewContainer}>
                    {isFreemium ? (
                        <Text style={globalStyles.secondaryDescription}>
                            {t('SETTINGS.DEVICE_LIMIT_DESCRIPTION___PACKAGE.BENEFIT')}
                        </Text>
                    ) : (
                        <>
                            <Text style={globalStyles.secondaryDescription}>
                                {t('SETTINGS.DEVICE_EXCEEDED')}
                            </Text>
                            <Text style={globalStyles.secondaryDescription}>
                                {t('SETTINGS.DEVICE_EXCEEDED_INFO')}
                            </Text>
                        </>
                    )}
                </ScrollView>
            </View>
            <View style={styles.buttonContainer}>
                <Button
                    style={confirmButtonStyle}
                    title={t('COMMON.OK')}
                    onPress={close}
                    isSecondary
                />
                <Button
                    style={buttonStyle}
                    title={t('SETTINGS.MANAGE_DEVICE_BTN')}
                    onPress={() => {
                        close();
                        navigation.navigate('DeviceManagement', { playerData });
                    }}
                />
            </View>
        </>
    );

    return (
        <View style={styles.window}>
            <Icon style={styles.closeIcon} name="close" onPress={close} />
            {Device.isTabletOrWeb ? (
                <View
                    style={{
                        ...styles.innerContainer,
                        height: isLandscape
                            ? getActualHeight() * 0.575
                            : styles.innerContainer.height
                    }}
                >
                    {content}
                </View>
            ) : (
                content
            )}
        </View>
    );
};

DeviceLimitDialog.defaultProps = {
    isLandscape: false,
    isFreemium: false
};

DeviceLimitDialog.propTypes = {
    playerData: PropTypes.object.isRequired,
    close: PropTypes.func.isRequired,
    isLandscape: PropTypes.bool,
    isFreemium: PropTypes.bool
};

export default DeviceLimitDialog;
